import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { Route, Switch } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'

import ProjectIndexPage from '../containers/Projects'
import ProjectShowPage from '../containers/Projects/show'

import appActions from '../redux/app/actions'

const { changeCurrent } = appActions

const ProjectsPage = ({
  location,
	match
}) => {
  const dispatch = useDispatch()
	const current = useSelector(state => state.getIn(['App', 'current'])).toJS()
	const { pathname } = location

	useEffect(() => {
		if (current[0] !== 'projects') {
			dispatch(changeCurrent(['projects']))
		}
	}, [pathname])

	const path = match.url

  return (
		<Switch>
			<Route path={`${path}/`} component={ProjectIndexPage} exact />
      <Route path={`${path}/:id`} component={ProjectShowPage} />
		</Switch>
  )
}

ProjectsPage.propTypes = {
  location: PropTypes.object.isRequired,
	match: PropTypes.object.isRequired
}

ProjectsPage.defaultProps = {}

export default ProjectsPage
